export const TOOLS_NOT_FOUND = "TOOLS_NOT_FOUND";
export const TOOLS_RESULT_NOT_FOUND = "TOOLS_RESULT_NOT_FOUND";

export const ALL_RESOURCES_NOT_FOUND = "ALL_RESOURCES_NOT_FOUND";
export const ALL_ARTICLES_NOT_FOUND = "ALL_ARTICLES_NOT_FOUND";
export const ALL_VIDEOS_NOT_FOUND = "ALL_VIDEOS_NOT_FOUND";
export const ARTICLE_NOT_FOUND = "ARTICLE_NOT_FOUND";
export const CATEGORY_NOT_FOUND = "CATEGORY_NOT_FOUND";
export const VIDEO_NOT_FOUND = "VIDEO_NOT_FOUND";
export const API_GRAPHQL_FETCH_DOCTOR_API = "API_GRAPHQL_FETCH_DOCTOR_API";
export const API_GRAPHQL_FETCH_DIAGNOSTICS_API = "API_GRAPHQL_FETCH_DIAGNOSTICS_API";
export const API_GRAPHQL_FETCH_DIAGNOSTICS_WIDGET_ITEMS_API = "API_GRAPHQL_FETCH_DIAGNOSTICS_WIDGET_ITEMS_API";
export const CLUSTER_NOT_FOUND = "CLUSTER_NOT_FOUND";
export const HOME_NOT_FOUND = "HOME_NOT_FOUND";
export const PILLAR_NOT_FOUND = "PILLAR_NOT_FOUND";
export const API_MAGENTO_CATEGORYTREE = "API_MAGENTO_CATEGORYTREE";
